module.exports = __webpack_public_path__ + "static/media/Concrete.860e3007.jpg";